module.exports = __webpack_public_path__ + "img/a4f3685ff214948716fb1a6bbd082abc.png";